
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"30","height":"30","viewBox":"0 0 30 30"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M3.752 8.415a.939.939 0 01-.086-1.873l2.545-.25a74.976 74.976 0 017.514-.38c4.156 0 8.4.212 12.614.63a.939.939 0 01-.185 1.868 126.43 126.43 0 00-12.429-.621 73.115 73.115 0 00-7.328.373l-2.552.249a.964.964 0 01-.093.004z","fill":"#ef5350"}}),_c('path',{attrs:{"data-name":"Vector","d":"M19.379 7.158a.939.939 0 01-.924-.782l-.276-1.627a2.421 2.421 0 00-.293-1.018 1.824 1.824 0 00-1.247-.29H13.36a1.876 1.876 0 00-1.246.273 2.461 2.461 0 00-.293 1.02l-.276 1.641a.939.939 0 11-1.851-.311l.275-1.639c.204-1.211.482-2.861 3.391-2.861h3.279c2.923 0 3.205 1.732 3.392 2.878l.274 1.621a.939.939 0 01-.927 1.1z","fill":"#ef5350","opacity":".34"}}),_c('path',{attrs:{"data-name":"Vector","d":"M19.01 28.436h-8.019c-1.918 0-3.146-.437-3.866-1.376a5.332 5.332 0 01-.8-2.989l-.816-12.608a.937.937 0 111.87-.121l.812 12.6a4.012 4.012 0 00.42 1.971c.327.426 1.127.642 2.38.642h8.019c1.252 0 2.053-.216 2.38-.642a4.023 4.023 0 00.42-1.977l.812-12.6a.937.937 0 111.87.121l-.812 12.6a5.341 5.341 0 01-.8 2.994c-.723.947-1.952 1.385-3.87 1.385z","fill":"#ef5350"}}),_c('path',{attrs:{"data-name":"Vector","d":"M17.077 21.563H12.91a.939.939 0 110-1.877h4.167a.939.939 0 110 1.877zM18.129 16.563h-6.257a.939.939 0 010-1.877h6.257a.939.939 0 110 1.877z","fill":"#ef5350","opacity":".34"}})])
          )
        }
      }
    